exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_wks-ext.js
// module id = 28
// module chunks = 0